import { User } from '@global/types/types';
import { getCookieValue, eraseCookie } from '@src/global/utils/cookie';

export const ALM_KEY = 'ALM-token';
export const VIAX_KEY = 'wiley-b2c-auth-token';
export const CONNECT_ACCESS_TOKEN_KEY = 'CONNECT_access_token';
export const CONNECT_ID_TOKEN_KEY = 'CONNECT_id_token';

export const clearTokensFromCookies = () => {
  eraseCookie(ALM_KEY);
  eraseCookie(VIAX_KEY);
  eraseCookie(CONNECT_ACCESS_TOKEN_KEY);
  eraseCookie(CONNECT_ID_TOKEN_KEY);
};

export const getTokensFromCookies = () => ({
  almToken: getCookieValue(ALM_KEY),
  viaxToken: getCookieValue(VIAX_KEY),
  connectAccessToken: getCookieValue(CONNECT_ACCESS_TOKEN_KEY),
  connectIdToken: getCookieValue(CONNECT_ID_TOKEN_KEY),
});

export const getUserFormToken = (token?: string) =>
  customParseJwt<User>(token || getTokensFromCookies()?.viaxToken);

export function customParseJwt<
  T = { exp: number; alm_guid: string; name: string }
>(token: string): undefined | T {
  if (token && token !== 'undefined') {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  } else return undefined;
}
